export default __webpack_public_path__ + "static/media/i154vp.8a4fd834.webp";